// Basic options - simple display/value pairs
export const basicOptions = [
  { display: 'Option One', value: 'opt1' },
  { display: 'Option Two', value: 'opt2' },
  { display: 'Option Three', value: 'opt3' },
  { display: 'Option Four', value: 'opt4' },
  { display: 'Option Five', value: 'opt5' },
];

// Options with icons
export const iconOptions = [
  { display: 'Settings', value: 'settings', icon: 'GearSix' },
  { display: 'Text', value: 'text', icon: 'TextT' },
  { display: 'Link', value: 'link', icon: 'LinkSimple' },
  { display: 'Upload', value: 'upload', icon: 'UploadSimple' },
  { display: 'Download', value: 'download', icon: 'DownloadSimple' },
];

// Options with color indicators
export const colorOptions = [
  { display: 'Red Tag', value: 'red', color: '#FF5733' },
  { display: 'Blue Tag', value: 'blue', color: '#3498DB' },
  { display: 'Green Tag', value: 'green', color: '#2ECC71' },
  { display: 'Purple Tag', value: 'purple', color: '#9B59B6' },
  { display: 'Orange Tag', value: 'orange', color: '#E67E22' },
];

// Options with descriptions
export const descOptions = [
  { display: 'Premium Plan', value: 'premium', desc: 'Full access to all features and priority support' },
  { display: 'Basic Plan', value: 'basic', desc: 'Limited features, great for starters' },
  { display: 'Enterprise', value: 'enterprise', desc: 'Custom solutions for large organizations' },
  { display: 'Free Tier', value: 'free', desc: 'Try out basic features at no cost' },
];

// Options with icons and descriptions combined
export const iconDescOptions = [
  { display: 'Analytics', value: 'analytics', icon: 'ChartDonut', desc: 'View analytics and reports' },
  { display: 'Messages', value: 'messages', icon: 'Chat', desc: '5 unread messages' },
  { display: 'Calendar', value: 'calendar', icon: 'CalendarBlank', desc: '3 upcoming events' },
  { display: 'Files', value: 'files', icon: 'FolderSimple', desc: 'Manage your documents' },
];

// Options demonstrating loading and disabled states
export const stateOptions = [
  { display: 'Normal Option', value: 'normal' },
  { display: 'Loading Option', value: 'loading', loading: true },
  { display: 'Disabled Option', value: 'disabled', disabled: true },
  { display: 'Another Normal', value: 'normal2' },
  { display: 'Also Disabled', value: 'disabled2', disabled: true },
];

// Basic grouped options
export const groupedOptions = [
  {
    display: 'Fruits',
    options: [
      { display: 'Apple', value: 'apple' },
      { display: 'Banana', value: 'banana' },
      { display: 'Orange', value: 'orange' },
    ]
  },
  {
    display: 'Vegetables',
    options: [
      { display: 'Carrot', value: 'carrot' },
      { display: 'Broccoli', value: 'broccoli' },
      { display: 'Spinach', value: 'spinach' },
    ]
  },
  {
    display: 'Dairy',
    options: [
      { display: 'Milk', value: 'milk' },
      { display: 'Cheese', value: 'cheese' },
      { display: 'Yogurt', value: 'yogurt' },
    ]
  }
];

// Grouped options with icons and descriptions
export const groupedWithIconsAndDesc = [
  {
    display: 'Content',
    options: [
      { display: 'Text Editor', value: 'text', icon: 'TextAa', desc: 'Write rich text content' },
      { display: 'Images', value: 'images', icon: 'ImageSquare', desc: 'Upload and manage images' },
      { display: 'Videos', value: 'videos', icon: 'VideoCamera', desc: 'Embed video content' },
    ]
  },
  {
    display: 'Tools',
    options: [
      { display: 'Settings', value: 'settings', icon: 'GearSix', desc: 'App preferences' },
      { display: 'Wrench', value: 'wrench', icon: 'Wrench', desc: 'Developer tools' },
      { display: 'Table', value: 'table', icon: 'Table', desc: 'Manage data tables' },
    ]
  }
];

// Long list for scroll testing
export const longOptions = Array.from({ length: 20 }, (_, i) => ({
  display: `Option ${i + 1}`,
  value: `option_${i + 1}`,
}));

// Mixed options with various properties
export const mixedOptions = [
  { display: 'With Icon', value: 'icon', icon: 'Tag' },
  { display: 'With Color', value: 'color', color: '#E74C3C' },
  { display: 'With Description', value: 'desc', desc: 'This option has a description' },
  { display: 'Icon + Desc', value: 'iconDesc', icon: 'CheckCircle', desc: 'Completed items' },
  { display: 'Disabled', value: 'disabled', disabled: true },
  { display: 'Plain Option', value: 'plain' },
];
